import { useContext } from "react";
import { AppContext } from "./AppContext";

export const DEMO_EMAIL = "matt+demo@bomdata.io";

const DEMO_USERS = ["matt@bomdata.io", DEMO_EMAIL, "mdlavin@gmail.com"];

export const useDemoMode = () => {
  const appContext = useContext(AppContext);
  return DEMO_USERS.includes(appContext.email);
};
